import { EmptyState } from '@app/components/base/EmptyState';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const equalMd5ReportEmptyHelp = defineMessage({
  id: 'audit.equalMd5Report.emptyState.help',
  defaultMessage:
    'Lista los archivos de media que comparten el mismo hash MD5 (es decir, mismo contenido de archivo) pero están registrados con distintos IDs de material. Útil para detectar y limpiar media duplicada.',
});

/**
 * Placeholder shown before the first equal-MD5 report run, explaining what the report calculates.
 */
export function EqualMd5ReportEmptyState() {
  return (
    <EmptyState
      icon={PlagiarismOutlinedIcon}
      message={false}
      help={<FormattedMessage {...equalMd5ReportEmptyHelp} />}
    />
  );
}
